/* eslint-disable @typescript-eslint/no-unused-vars */

import {EEventType, IEventData} from 'coreClasses/events/IEvents';

/**
 * Represents AbstractAnalyticProvider
 */
class AbstractAnalyticProvider {
	/**
	 * Tracks analytics event
	 * @param {string | EEventType} eventType - event type
	 * @param {IEventData} eventData - event data
	 */
	update(eventType: string | EEventType, eventData: IEventData): void {
		throw new Error('Method update must be implemented');
	}
}

export default AbstractAnalyticProvider;
